import React, { useEffect } from 'react'
import { customerLoginApi } from '../../services/redux/ApiActions';
import { useLocation, useNavigate } from 'react-router-dom';
import Bowser from 'bowser';
import { useDispatch } from 'react-redux';

const Loading = () => {
    const location = useLocation();
    const token = location.pathname.split('/').pop();
    const userAgent = window.navigator.userAgent;
    const parsedInfo = Bowser.parse(userAgent);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const getToken = async () => {
            const data = {
                "mailToken": token,
                "createdIp": "",
                "createdUserAgent": ''
            }
            try {
                const response = await dispatch(customerLoginApi(data));
                if (response.statusCode === 200) {
                    console.log(response); // Assuming your response data is stored in the component state
                    var tokenData = token
                    navigate('/customer/login', {
                        state: {
                            // Your state data here
                            data: response.result,
                            token: tokenData,
                            // Add more key-value pairs as needed
                        }
                    });
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        getToken();
    }, []);
    return (
        <div>

        </div>
    )
}

export default Loading
